const errorComponentStyle = {
  '.errorContainer': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
  },
  '.headingMessage': {
    color: '#333333',
    fontFamily: 'BentonSans',
    fontSize: '20px',
    letterSpacing: '0',
    lineHeight: '28px',
    textAlign: 'center',
  },
  '.subHeading': {
    color: '#333333',
    fontFamily: '"Helvetica Neue"',
    fontSize: '16px',
    letterSpacing: '0',
    lineHeight: '24px',
    textAlign: 'center',
  },
};

export default errorComponentStyle;
